import { SAFE_DOMAIN_LIST } from '../constants/safeDomains';

function sendPostMessage(data) {
  SAFE_DOMAIN_LIST.forEach(domain => {
    window?.parent?.postMessage(data, `https://${domain}`);
  });
}

export { sendPostMessage };
